import React from 'react';
import { Button, IconShield, Modal } from 'gatorcomponents';
import BrandByMonarx from '@/components/GatorProtect/BrandByMonarx/BrandByMonarx';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';
import * as Styles from './GatorProtectDetectedThreadsModal.styles';

const MOBILE_BREAKPOINT = 425;

const GatorProtectDetectedThreadsModal = ({
  onClose,
  onPrimary,
  threatCount,
}) => {
  const { width } = useResize();
  const isMobile = width <= MOBILE_BREAKPOINT;
  const { gatorProtect: gatorProtectLocale } = useLocale();

  if (!gatorProtectLocale?.detectedThreadsModal) {
    return null;
  }
  const { detectedThreadsModal } = gatorProtectLocale;

  return (
    <Modal
      onClose={onClose}
      maxWidth={isMobile ? '100%' : 800}
      mobileMaxHeight={360}
      noHeader
      testId="gator-protect-detected-threads-modal"
    >
      <Styles.Root $isMobile={isMobile} data-testid="gator-protect-detected-threads-modal__content">
        <Styles.BrandByMonarxWrapper $isMobile={isMobile}>
          <BrandByMonarx
            isMobile={isMobile}
            shieldVariant="red"
            variant="light"
          />
        </Styles.BrandByMonarxWrapper>

        <Styles.MessageBlock $isMobile={isMobile}>
          <Styles.Headline $isMobile={isMobile}>{detectedThreadsModal.headline}</Styles.Headline>
          <Styles.BodyText $isMobile={isMobile}>
            {detectedThreadsModal.bodyPrefix}
            <strong>{detectedThreadsModal.threatsBold({ count: threatCount })}</strong>
            {detectedThreadsModal.bodySuffixLine1}
            <br aria-hidden="true" />
            {` ${detectedThreadsModal.bodyLine2}`}
          </Styles.BodyText>
        </Styles.MessageBlock>

        <Styles.PrimaryButtonWrap>
          <Button
            label={detectedThreadsModal.primaryCta}
            onClick={onPrimary}
            size="large"
            variant="primary"
            notFillSVG
            iconLeft={<IconShield size="md" color="highPure" />}
          />
        </Styles.PrimaryButtonWrap>
      </Styles.Root>
    </Modal>
  );
};

export default GatorProtectDetectedThreadsModal;
